var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaderboardBonusesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chart-line",
    "data-name": "Icon awesome-chart-line",
    d: "M34.875,27H4.5V5.625A1.125,1.125,0,0,0,3.375,4.5H1.125A1.125,1.125,0,0,0,0,5.625V29.25A2.25,2.25,0,0,0,2.25,31.5H34.875A1.125,1.125,0,0,0,36,30.375v-2.25A1.125,1.125,0,0,0,34.875,27ZM32.625,6.75h-8.3a1.687,1.687,0,0,0-1.193,2.881l2.278,2.278-5.159,5.16L15.091,11.91a2.249,2.249,0,0,0-3.182,0l-4.83,4.83a1.125,1.125,0,0,0,0,1.591l1.59,1.59a1.125,1.125,0,0,0,1.591,0L13.5,16.682l5.159,5.159a2.249,2.249,0,0,0,3.182,0l6.75-6.75,2.278,2.278a1.687,1.687,0,0,0,2.881-1.193v-8.3A1.124,1.124,0,0,0,32.625,6.75Z",
    transform: "translate(0 -4.5)",
    fill: "#3d3d3d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardBonusesIcon);
export default __webpack_public_path__ + "static/media/leaderboard-bonuses-icon.8a4f7a0db934488c25aad988acbe049b.svg";
export { ForwardRef as ReactComponent };